import React from 'react';
import classNames from 'classnames';
import cls from './ModalBodyTableReconciliation.module.css';
import { useModalBodyTableReconciliation } from './useModalBodyTableReconciliation';
import { TableHeaderReconciliation } from '../../../../Blocks/FinancialIndicatorsBlock/UI/TableFinancialIndicators/UI/TableHeaderReconciliation/TableHeaderReconciliation';
import { TableRowReconciliation } from '../../../../Blocks/FinancialIndicatorsBlock/UI/TableFinancialIndicators/UI/TableRowReconciliation/TableRowReconciliation';
import { TableFooterReconciliation } from '../../../../Blocks/FinancialIndicatorsBlock/UI/TableFinancialIndicators/UI/TableFooterReconciliation/TableFooterReconciliation';
import { ReconciliationInformation } from '../useModalBodyReconciliationOfCalculations';

interface ModalBodyTableReconciliationProps {
    classes?: string;
    calculationsInformation: ReconciliationInformation;
}

export const ModalBodyTableReconciliation = ({
    classes,
    calculationsInformation,
}: ModalBodyTableReconciliationProps) => {
    const { sign } = useModalBodyTableReconciliation();
    return (
        <div className={classNames(cls.ModalBodyTableReconciliation, [classes])}>
            <TableHeaderReconciliation />
            {calculationsInformation.estimates.map((estimate, index) => (
                <TableRowReconciliation
                    key={index}
                    title={estimate.estimate_name}
                    //@ts-ignore
                    contractPrice={numberFormatter.formatNumber(estimate.vat_cost)}
                    //@ts-ignore
                    orderSum={numberFormatter.formatNumber(estimate.order_completion_sum)}
                    //@ts-ignore
                    customerBePaid={numberFormatter.formatNumber(estimate.customer_payment)}
                    //@ts-ignore
                    customerPayment={numberFormatter.formatNumber(
                        estimate.customer_remain_payment_act
                    )}
                    //@ts-ignore
                    currencyCode={estimate.currency_short_code}
                />
            ))}
            {calculationsInformation.total.length === 0 ? (
                <TableFooterReconciliation
                    key={Math.random().toString(36)}
                    //@ts-ignore
                    contractPrice={0}
                    //@ts-ignore
                    orderSum={0}
                    //@ts-ignore
                    customerBePaid={0}
                    //@ts-ignore
                    customerPayment={0}
                    //@ts-ignore
                    currencyCode={sign}
                />
            ) : (
                calculationsInformation.total.map((estimate, index) => (
                    <TableFooterReconciliation
                        key={index}
                        //@ts-ignore
                        contractPrice={numberFormatter.formatNumber(estimate.vat_cost)}
                        //@ts-ignore
                        orderSum={numberFormatter.formatNumber(estimate.order_completion_sum)}
                        //@ts-ignore
                        customerBePaid={numberFormatter.formatNumber(estimate.customer_payment)}
                        //@ts-ignore
                        customerPayment={numberFormatter.formatNumber(
                            estimate.customer_remain_payment_act
                        )}
                        //@ts-ignore
                        currencyCode={estimate.currency_short_code}
                    />
                ))
            )}
        </div>
    );
};
